import React from 'react';
import styled from 'styled-components';
import { Icon, Text, theme } from 'components';

const PlanContainer: React.FC<{ isCurrentPlan?: boolean }> = ({
  isCurrentPlan = false,
  children,
}) => (
  <StyledPlanContainer $isCurrentPlan={isCurrentPlan}>
    {isCurrentPlan && (
      <>
        <StyledCurrentPlanHeader>
          <StyledCurrentPlanText>Current Plan</StyledCurrentPlanText>
          <Icon type="checkCircle" color="info" />
        </StyledCurrentPlanHeader>
        <StyledBlueLine />
      </>
    )}
    {children}
  </StyledPlanContainer>
);

export default PlanContainer;

const StyledPlanContainer = styled.div<{ $isCurrentPlan: boolean }>`
  border: ${({ $isCurrentPlan }) =>
    $isCurrentPlan ? `2px solid ${theme.blue6}` : `1px solid ${theme.gray4}`};
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  min-width: 400px;
  justify-content: space-between;
`;

const StyledCurrentPlanHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 8px 16px;
`;

const StyledCurrentPlanText = styled(Text)`
  align-self: center;
  font-weight: bold;
`;

const StyledBlueLine = styled.div`
  border-bottom: 2px solid ${theme.blue6};
`;
